import { ErrorMessage, SDKError } from "./backend"

export interface VPurchaseRequest {
    deviceId: string
    accountId: string
    assuranceData: {
        fidoBlob: string
        identifier: string
    }
    dfpSessionId: string
    amount: string
    currencyCode: string
    mandateId: string
    description: string
    requestId: string
}
export interface VPurchaseResponse {
    instructionId: string
}

export interface VInitRequest {
    accountId: string
    sessionContext: {
        secureToken: string
    },
    browserData: {
        userAgent: string
    },
    requestId: string,
}
export interface VInitResponse {
    id: string
    authenticationContext: {
        endpoint: string,
        identifier: string,
        payload: string,
        action: string,
        platform: string,
        authenticationPreferencesEnabled: {
            responseMode: string,
            responseType: string,
        }
    }
}

export interface VPanEnroll {
    deviceId: string
    accountId: string
    accountNumber: string
    panMonth: string
    panYear: string
    cvv: string
}
const walletUrl = process.env.REACT_APP_WALLET_URL || "";
export class VisaService {
    static async visaEnroll(request:VPanEnroll) {
        try {

            const reg_url = walletUrl + "/visa/pan/enroll";
            const response = await fetch(reg_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(request)
            })
            if (response.ok) {
                const res = await response.json();
                return Promise.resolve(res);
            } else {
                const e: ErrorMessage = await response.json();
                return Promise.reject(new SDKError(e.message));
            }
        } catch (error) {
            console.log("vinit error: ", error);
            return Promise.reject(new SDKError("fail vinit"));
        }
    }
    
    static async visaInit(request: VInitRequest): Promise<VInitResponse> {
        try {

            const reg_url = walletUrl + "/visa/purchase/init";
            const response = await fetch(reg_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(request)
            })
            if (response.ok) {
                const res = await response.json();
                return Promise.resolve(res);
            } else {
                const e: ErrorMessage = await response.json();
                return Promise.reject(new SDKError(e.message));
            }
        } catch (error) {
            console.log("vinit error: ", error);
            return Promise.reject(new SDKError("fail vinit"));
        }
    }

    static async purchase(request: VPurchaseRequest): Promise<VPurchaseResponse> {
        try {

            const reg_url = walletUrl + "/visa/purchase/credential";
            const response = await fetch(reg_url, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(request)
            })
            if (response.ok) {
                const res = await response.json();
                return Promise.resolve(res);
            } else {
                const e: ErrorMessage = await response.json();
                return Promise.reject(new SDKError(e.message));
            }
        } catch (error) {
            console.log("vinit error: ", error);
            return Promise.reject(new SDKError("fail vinit"));
        }
    }
}